import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import { Parameter, Thread } from '@reporting/rp-types/etl';
import { msg } from '@omegagrid/localize';
import rp from '@reporting/rp-app-host';

const dataTypes = ['int', 'bigint', 'nvarchar(20)'];

export class ParamFormAdapter extends FormAdapter {

	constructor(
		public idThread?: number,
		public idzParam?: number,
	) { super() }

	getColumns() {
		return [
			{width: 80},
			{width: null},
		];
	}

	async getControls() {
		const param = this.idzParam ? (
			await rp.ms('etl').get<Parameter>(`threads/${this.idThread}/parameters/${this.idzParam}`)
		) : {};

		return [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('Name'), for: 'name'},
			{row: 0, col: 1, type: FormControlType.TextInput, key: 'name', value: param.name, required: true, placeholder: msg('SQL variable name')},
			{row: 1, col: 0, type: FormControlType.Label, value: msg('Type'), for: 'data_type'},
			{row: 1, col: 1, type: FormControlType.TextInput, value: param.data_type, key: 'data_type', required: true, placeholder: msg('SQL data type')},
			// {row: 1, col: 1, type: FormControlType.List, key: 'data_type', value: param.data_type, required: true, content: {
			// 	sourceData: dataTypes.map(t => ({k: t, v: t})), options: {
			// 		selectMode: 'single', autoClose: true, allowEmpty: false
			// 	}
			// }},
			{row: 2, col: 0, type: FormControlType.Label, value: msg('Description'), for: 'description'},
			{row: 2, col: 1, type: FormControlType.TextInput, key: 'description', value: param.description, required: false},
			{row: 3, col: 0, type: FormControlType.Label, value: msg('Order'), for: 'ord_num'},
			{row: 3, col: 1, type: FormControlType.NumericInput, key: 'ord_num', value: param.ord_num ?? null, required: false},
			{row: 4, col: 0, type: FormControlType.Label, value: msg('Scope')},
			{row: 4, col: 1, type: FormControlType.List, key: 'global', value: (param.global ? 1 : 0).toString(), content: {
				sourceData: [{k: '0', v: msg('Local')}, {k: '1', v: msg('Global')}],
				options: {
					selectMode: 'single', autoClose: true, allowEmpty: false
				}
			}},
			{row: 5, col: 0, type: FormControlType.Label, value: msg('Value')},
			{row: 5, col: 1, type: FormControlType.List, value: (param.default_value_sql ? 1 : 0).toString(), key: 'default_value_sql', content: {
				sourceData: [{k: '0', v: msg('Constant')}, {k: '1', v: msg('SQL')}],
				options: {
					selectMode: 'single', autoClose: true, allowEmpty: false
				}
			}},
			{row: 6, col: 1, type: FormControlType.TextInput, key: 'default_value', value: param.default_value, required: false},
			{row: 7, col: 0, type: FormControlType.Label, value: msg('List')},
			{row: 7, col: 1, type: FormControlType.List, key: 'id_thread_list', value: param.id_thread_list, content: {
				sourceData: [
					{k: '-1', v: 'Custom - SQL'},
					{k: '-2', v: 'Custom - JSON'},
					...([])
				],
				options: {
					selectMode: 'single', autoClose: true, allowEmpty: true
				}
			}},
		];
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: ["save", "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		// a cleared numeric input reports NaN; null is sent on purpose so the stored order gets dropped
		const ordNum = formValues.ord_num == null ? NaN : Number(formValues.ord_num);
		const parameter: Parameter = {
			idz: this.idzParam,
			name: formValues.name as string,
			description: formValues.description as string,
			data_type: formValues.data_type as string,
			ord_num: Number.isFinite(ordNum) ? ordNum : null,
			global: formValues.global == '1',
			default_value_sql: formValues.default_value_sql == '1',
			default_value: formValues.default_value as string,
			id_thread_list: formValues.id_thread_list ? parseInt(formValues.id_thread_list as string) : null,
			id_thread: this.idThread
		};
		// every save soft-deletes the current row and inserts a new one, so the idz changes
		const saved = await rp.ms('etl').post<Parameter>(`threads/${this.idThread}/parameters`, parameter);
		if (saved?.idz) this.idzParam = saved.idz;
		return true;
		// return [{text: 'Error', type: 'danger'}];
	}
};
